export async function api(path, options = {}) {
  const { retry = 0, retryDelay = 650, timeoutMs = 12000, ...fetchOptions } = options;
  let response;
  let lastNetworkError;
  for (let attempt = 0; attempt <= retry; attempt += 1) {
    let timeout;
    try {
      const controller = new AbortController();
      timeout = window.setTimeout(() => controller.abort(), timeoutMs);
      response = await fetch(`/public/api${path}`, {
        credentials: "same-origin",
        cache: "no-store",
        ...fetchOptions,
        signal: controller.signal,
        headers: {
          Accept: "application/json",
          ...(fetchOptions.body ? { "Content-Type": "application/json" } : {}),
          ...fetchOptions.headers,
        },
      });
      window.clearTimeout(timeout);
      break;
    } catch (networkError) {
      window.clearTimeout(timeout);
      lastNetworkError = networkError;
      if (attempt < retry) {
        await new Promise((resolve) => window.setTimeout(resolve, retryDelay * (attempt + 1)));
      }
    }
  }

  if (!response) {
    const error = new Error("Conexión inestable. La aplicación volverá a intentarlo automáticamente.");
    error.cause = lastNetworkError;
    error.isNetworkError = true;
    throw error;
  }

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || data.error || "No se pudo completar la solicitud.");
  }
  return data;
}

export async function authenticatedApi(path, token, options = {}) {
  return api(path, {
    ...options,
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
}

export async function authenticatedUpload(path, token, formData) {
  const response = await fetch(`/public/api${path}`, {
    method: "POST",
    credentials: "same-origin",
    cache: "no-store",
    headers: {
      Accept: "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: formData,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || data.error || "No se pudo completar la solicitud.");
  }
  return data;
}

export function getSavedAddress() {
  try {
    const value = JSON.parse(localStorage.getItem("userSetAddress") || "null");
    const geoLocation = JSON.parse(localStorage.getItem("geoLocation") || "null");
    if (!value?.address) return null;

    const geoPoint = geoLocation?.geometry?.location || {};
    const lat = Number(value.lat ?? value.latitude ?? geoPoint.lat ?? geoPoint.latitude);
    const lng = Number(
      value.lng
      ?? value.lon
      ?? value.longitude
      ?? geoPoint.lng
      ?? geoPoint.lon
      ?? geoPoint.longitude,
    );

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    return { ...value, lat, lng };
  } catch {
    return null;
  }
}

export function saveAddress({ lat, lng, address, accuracy = 0, house = null, tag = null, savedId = null }) {
  const userAddress = {
    lat,
    lng,
    address,
    accuracy: Math.max(0, Number(accuracy || 0)),
    house,
    tag,
    savedId,
    businessLocation: true,
  };
  const geoLocation = {
    formatted_address: address,
    geometry: { location: { lat, lng } },
  };
  localStorage.setItem("userSetAddress", JSON.stringify(userAddress));
  localStorage.setItem("geoLocation", JSON.stringify(geoLocation));
  localStorage.setItem("userAlreadySelectedLocation", "true");
  return userAddress;
}
